import PropTypes from 'prop-types';

export const rosterType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  mediaPacks: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
});
